module.exports = __webpack_public_path__ + "static/tdd-64f43b2281d69b4c86d1221b8d9c50f7.png";